import { RecordFilter } from '@indigohive/cogfy-types'

export function filterIsActive (filter: RecordFilter) {
  return Object.entries(filter)
    .filter(([key, _value]) => key !== 'property' && key !== 'propertyType')
    .filter(([_key, value]) => value !== undefined && value !== '')
    .length > 0
}
